import SEOPageTemplate from '../components/SEOPageTemplate';

const ChauffeurBangor = () => (
  <SEOPageTemplate
    city="Bangor"
    state="ME"
    route="/chauffeur-bangor-me"
    imageSrc="/bangor-me-limo.jpg"
    introduction="In Bangor, Maine's gateway to the north, TiLimousine delivers a transportation service that understands the unique character of this historic city. Our chauffeurs are intimately familiar with Bangor's distinctive charm, from the vibrant downtown to the serene waterfront. Whether you're visiting for business at the Cross Insurance Center, exploring the city's growing healthcare sector, or heading to Acadia National Park, our service ensures your journey through Bangor is as welcoming as the city itself."
    testimonial={{
      quote: "As a healthcare executive, I frequently host medical professionals visiting our Bangor facilities. TiLimousine's chauffeurs understand the importance of reliable transportation in our industry. Their knowledge of Bangor's healthcare landscape and local amenities has been invaluable for our business.",
      author: "Dr. William H.",
      role: "Medical Director, Bangor Regional Hospital"
    }}
    services={[
      'Luxury chauffeur service for airport transfers and FBO pickup',
      'Executive car service and black car service for business travel',
      'Hourly chauffeur hire and as-directed black car service',
      'Private driver service for events, weddings, and VIPs',
      'Long-distance city-to-city rides: Bangor ⇄ Portland, Bangor ⇄ Boston',
      'Professional chauffeur company for meetings and corporate events',
      'Livery service and luxury livery transportation',
      'Town car service and car and driver rental',
      'Book a chauffeur in Bangor',
      'Best chauffeur in Maine',
      'Chauffeured transportation for VIPs',
      'Luxury car with driver',
      'Business travel car service',
      'Limo vs black car service Bangor',
      'Best executive car service in Bangor',
      'FBO pickup with luxury car',
      'Chauffeur for meetings and corporate events'
    ]}
    airports={[
      'Bangor International Airport (BGR)',
      'Signature Flight Support',
      'Atlantic Aviation',
      'Portland International Jetport (PWM)',
      'Logan International Airport (BOS)',
      'Teterboro Airport (TEB)',
      'JFK',
      'LGA'
    ]}
    neighborhoods={[
      'Downtown Bangor',
      'Bangor Mall Area',
      'West Side',
      'East Side',
      'Bangor Waterfront',
      'Hammond Street',
      'Stillwater Avenue',
      'Husson University',
      'Bangor International Airport Area',
      'Bangor Business District',
      'Bangor Cross Center',
      'Greater Bangor Area'
    ]}
  />
);

export default ChauffeurBangor; 